import {
  useCurrentStepIndex,
  useWizardService,
  useForm,
  usePage,
  useForms,
} from '@kizi/comparator-core';
import { Button, ButtonProps } from '@kizi/core-components';
import React from 'react';

export interface SubmitModalWithStepsButtonProps extends ButtonProps {
  forms: string[];
}

export const SubmitModalWithStepsButton: React.FC<SubmitModalWithStepsButtonProps> =
  ({ forms, ...restProps }) => {
    const wizardStepIndex = useCurrentStepIndex() ?? '';
    const { send, state: formState } = useForm(wizardStepIndex);
    const { setState, state } = usePage();
    const wizard = useWizardService();
    const _forms = useForms(forms);

    if (!send || !formState || !state || !setState || !wizard || !_forms)
      return null;

    const onClick = () => {
      const { filters, steps } = state;
      const _steps = steps as any;
      const modalData = _forms
        ?.map((form) =>
          form.state.context.fields.map((field) => {
            return {
              name: field.name,
              value: field.value,
            };
          })
        )
        .flat();

      for (let field of modalData) {
        if (field !== undefined) {
          if (
            (filters as { [key: string]: any })[field.name] &&
            field.value !== undefined
          ) {
            const { name, value } = field;
            (filters as { [key: string]: any })[name] = JSON.parse(
              value.toString()
            );
          }
        }
      }

      const getField = (fieldName, data) => {
        return data.find((f) => f.name === fieldName);
      };

      for (let step of _steps) {
        const { fields } = step;
        fields.forEach((field, i) => {
          const { name } = field;
          const data = getField(name, modalData);
          if (data?.value !== undefined) {
            fields[i] = {
              name: name,
              value: data.value,
            };
          }
        });
      }

      (state.onSubmit as Function)(filters, _steps);
      wizard?.send('SUBMIT');
    };

    return <Button onClick={onClick} {...restProps} />;
  };
